import { render, staticRenderFns } from "./TreeselectCustom.vue?vue&type=template&id=748e8ffa&scoped=true&"
import script from "./TreeselectCustom.vue?vue&type=script&lang=js&"
export * from "./TreeselectCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748e8ffa",
  null
  
)

export default component.exports